// extracted by mini-css-extract-plugin
module.exports = {"menu":"Menu_menu__6OLBw","link":"Menu_link__h6Skf","text":"Menu_text__drSg2","active":"Menu_active__HLp3k"};